import { render, staticRenderFns } from "./StaffStep.vue?vue&type=template&id=cdac6d18&scoped=true"
import script from "./StaffStep.vue?vue&type=script&lang=ts"
export * from "./StaffStep.vue?vue&type=script&lang=ts"
import style0 from "./StaffStep.vue?vue&type=style&index=0&id=cdac6d18&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdac6d18",
  null
  
)

export default component.exports